// extracted by mini-css-extract-plugin
module.exports = {"tag":"canlanderPointsTag_tag__nqZQ0"};